import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORY_LABELS } from "@/lib/format";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ArticleCard } from "@/components/site/ArticleCard";

export default function Category() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback((p) => {
    setLoading(true);
    api.get("/articles", { params: { category: slug, page: p, limit: 12 } })
      .then((r) => {
        setItems((prev) => (p === 1 ? r.data.items : [...prev, ...r.data.items]));
        setPages(r.data.pages); setTotal(r.data.total); setPage(p);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => { setItems([]); load(1); }, [slug, load]);

  return (
    <SiteLayout>
      <div className="max-w-[1240px] mx-auto px-4 py-8">
        <header className="border-b-2 border-prussian pb-4 mb-8">
          <h1 data-testid="category-title" className="font-headline font-black text-prussian text-4xl md:text-5xl tracking-tight">
            {CATEGORY_LABELS[slug] || slug}
          </h1>
          <p className="text-sm text-muted-foreground font-body mt-2">{total} Beiträge in dieser Rubrik</p>
        </header>

        <div data-testid="category-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>

        {items.length === 0 && !loading && (
          <p className="text-center text-muted-foreground py-16 font-body">Noch keine Artikel in dieser Rubrik.</p>
        )}

        {page < pages && (
          <div className="text-center mt-10">
            <button data-testid="load-more-btn" onClick={() => load(page + 1)} disabled={loading}
              className="bg-prussian text-white font-body font-semibold text-sm uppercase tracking-wide px-8 py-3 hover:bg-prussian-dark transition-colors disabled:opacity-50">
              {loading ? "Lädt…" : "Weitere Artikel laden"}
            </button>
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
